import { render, staticRenderFns } from "./NewBDXIconNavItem.vue?vue&type=template&id=6c624278"
import script from "./NewBDXIconNavItem.vue?vue&type=script&lang=js"
export * from "./NewBDXIconNavItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports